import { Link } from "react-router-dom";
import styled from "styled-components";
import { tabActionButtonCss } from "./detailActionButtonCss";

const TabBar = styled.nav`
  display: flex;
  align-items: flex-end;
  margin: 8px 24px 0;
  border-bottom: 1px solid #d3dbe8;
`;

const TabList = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

const TabActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  margin-bottom: 8px;

  &:empty {
    display: none;
  }
`;

const Tab = styled(Link)`
  margin-bottom: -1px;
  padding: 8px 16px;
  border: 1px solid #d3dbe8;
  border-bottom-color: #d3dbe8;
  border-radius: 6px 6px 0 0;
  background: #fff;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-decoration: none;

  &.activeItem {
    background: #eef2f7;
    color: #1249bf;
    border-bottom-color: #eef2f7;
  }

  &:hover:not(.activeItem) {
    background: #f4f7ff;
    color: #1249bf;
  }
`;

const TabActionButtonGroup = styled.div`
  display: contents;

  button {
    ${tabActionButtonCss}
  }

  button.editColumnsIcon {
    --edit-columns-plate: #fff;
    width: 34px;
    min-width: 34px;
    padding: 0 !important;

    .editColumnsPlate {
      fill: var(--edit-columns-plate);
    }

    &:hover:not(:disabled) {
      --edit-columns-plate: #f4f7ff;
    }
  }
`;

export { Tab, TabActionButtonGroup, TabActions, TabBar, TabList };
